// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/Pattern 2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/icons/Ellipse 21.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  background-color: #F1F5F7;
}

* {
  font-family: 'Sora', sans-serif;
  scroll-behavior: smooth;
}

.container-fluid {
  max-height: 100vh;
  overflow-y: auto;
}

.horizontal-container {
  display: grid;
  height: 100vh;
}

.horizontal-div {
  height: 380px;
  flex: 1 1;
  background-color: #F1F5F7;
}

.navbar {
  position: absolute;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background-color: transparent;
  color: #fff;
}

.navbar-right {
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: center;

}

.navbar-right li {
  margin-right: 5px;
}

.logout-button-mobile{
  display: none;
}

.companyButton {
  display: flex;
  margin-bottom: 30px;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  background-color: #50536789;
  border: none;
  border-radius: 5px;
  padding: 10px;
  color: #F15F50;
}

.navbar-logo {
  margin-left: 100px;
  margin-top: 30px;
  display: flex;
  padding: 20px;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border-radius: 75px;
  background-color: #FFFF;
}

.navbar-logo img {
  width: 85px;
  height: 65px;
}

.navbar-links {
  font-weight: 100;
  font-size: 20px;
  cursor: pointer;
  list-style: none;
  display: flex;
}

.navbar-links li {
  margin-right: 20px;
}

.navbar-links li button {
  background-color: transparent;
  border: none;
  font-weight: 100;
  color: #fff;
  cursor: pointer;
  line-height: 34px;
  font-size: 24px;
  transition: color 0.3s, font-weight 0.3s;
}

.navbar-links li button.active {
  background-image: linear-gradient(90deg, #F15F50 0%, #F9B061 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: 700;
}



.navbar-links li button:focus {
  outline: none;
}


.upper-div {
  background-color: #1D1E25;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position-x: -10px;
  background-position-y: -60px;
  background-size: 454px;
  display: flex;

}


.left-content {
  position: relative;
}

.left-content::after {
  content: '';
  position: absolute;
  top: 0;
  right: 57%;
  width: 1px;
  height: 130px;
  background-color: #c7c8c9;
}

@media screen and (min-width: 1501px) {
  .left-content::after {

    right: 60%;

  }

}

@media screen and (max-width: 1500px) {
  .left-content::after {

    right: 55%;

  }

}

.second-div {
  background-color: #F1F5F7;
  width: 100%;
}

.overlay-div {
  border-radius: 25px;
  position: absolute;



  z-index: 10;
  background-color: #ffff;
  border-radius: 5px;
  top: 240px;
  left: 90px;
  width: calc(100% - 180px);
  height: calc(100vh - 280px);
  /* overflow-y: hidden;
  overflow-x: hidden; */
}


.companyTitle {
  width: 100%;
  color: #FFFF;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 15px;
  margin-left: 55px;
  margin-right: 55px;
  margin-bottom: 120px;

}

.companyTitle h2 {
  font-weight: 100;
  font-size: 36px;
  line-height: 46px;
}

@media (max-width: 768px) {
  .horizontal-container {
    grid-template-columns: 1fr;
  }
}


.backgroundDiv {
  height: calc(100vh - 280px);
  padding: 0px;
}

.backgroundDiv img {
  height: 100%;
  width: 100%;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 12px;
}

.contentDiv p {
  font-size: 16px;
  width: 90%;
  overflow: auto;
}

.contentDiv {
  height: calc(100vh - 280px);
  padding: 16px;
  margin-left: 32px;
}

.row>* {
  padding: 0px;
}

.titleOnline h2 {
  font-weight: 100 !important;
  margin-top: 20px;
  font-size: 36px;
}

.upperContent {
  max-width: -moz-fit-content;
  max-width: fit-content;
  max-height: 100%;
}


.upperContent-p {
  font-weight: 200;
  font-size: 20px !important;
  width: 100% !important;
  padding: 0px !important;
}

.upperContent button {
  border-radius: 12px;
  background-color: #fff;
  padding: 16px 32px;
  border: 2px dashed #87CCA1;
  font-weight: 600;
  font-size: 25px;
  margin-bottom: 25px;
}

.timeButtons{
  width: 95%;
  padding: 32px;
  border: 1px solid #1D1E2533;
  border-radius: 8px;
  margin-bottom: 40px;
  background-color: #F1F5F7;
}
.timeButtons button {
  border: 2px dashed #1D1E251A;
  color: #1D1E25CC;
  width: 120px;
  height: 60px;
  padding: 10px;
  font-size: 20px;
  background-color: #FFFF;
  border-radius: 8px;
  margin-right: 5px;
  margin-bottom: 5px;
  font-weight: 700;
}

.timeButtonsForExtendSession {
  background-color: #F9FBFC !important;
  padding: 30px;
  border: 1px solid #1D1E2533;
  border-radius: 8px;
  height: 300px !important;
  width: 95%;
  margin-bottom: 40px;
}

.timeButtonsForExtendSession button {
  width: 120px !important;
  height: 60px !important;
  border: 2px dashed #1D1E2533;
  margin-right: 8px;
  color: #1D1E2533;
  padding: 0px !important;
}


.saleButtons button {
  border: 2px dashed #1D1E2533;
  margin-right: 8px;
  color: #1D1E2533;
}


.selected-button {
  border: 2px dashed #1D1E25 !important;
  background: linear-gradient(90deg, #F15F50 0%, #F9B061 100%);
  color: #fff !important;
}

.contract {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  border: 1px solid #1D1E2533;
  border-radius: 8px;
  margin-bottom: 24px;
  width: 100%;


}

.contract p {
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 0px !important;


}

.contract a {
  color: #F15F50 !important;
}


.companyBecomeOnlineButton button {
  background-color: #F15F50;
  border: none;
  padding: 18px 22px;
  width: 312px;
  height: 56px;
  border-radius: 12px;
  justify-content: space-between;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
}
.companyBecomeOnlineButton button:disabled{
  background-color: #1D1E2533;
  color: #1D1E2566;
}

.liveRightNov {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stop-session-button {
  border: 1px solid #1D1E2533;
  background-color: #FFFF;
  justify-content: space-between;
  padding: 18px 22px;
  width: 142px;
  height: 56px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
}

.liveRightNowUpperParagraph {
  font-weight: 400 !important;
  font-size: 24px;
  line-height: 34px;
}

.timerButton {
  border: 2px dashed #1D1E25 !important;
}

.timerButtonExtendSession {
  border: none !important;
  text-align: left;
  font-weight: 600;
  font-size: 30px !important;
  padding: 0px !important;
}

.timePickerButtons {
  width: 50px !important;
  height: 50px;
}

.ReactModal__Content {
  inset: 100% !important;
}

.custom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  width: 100%;
  max-width: 800px;
  height: 750px;
  background: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1001;
  padding: 20px;
  border-radius: 8px;
}


/* .stop-session-pop-up{
  width: 50%;
  inset:0px !important;
} */

.companyInfoFormContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;

}

.companyInfoForm {
  width: 90%;
  margin-left: 32px;
}

.stopSession {
  display: flex;
  justify-content: space-between;
  align-items: start;
}

.stopSession button {
  background-color: #FFFF;
  border: 1px solid #1D1E251A;
  padding: 18px 22px;
  width: 130px;
  height: 56px;
  border-radius: 12px;
  justify-content: space-between;
  font-weight: 600;
  font-size: 16px;
}

.content h5 {
  color: #CD3636;
  font-weight: 400;
  font-size: 24px;
  line-height: 34px;
  margin-top: 50px;
}

.stopSessionFirstP {
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
}

.stopSessionSecondP {
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
}

.qrCount {
  color: #CD3636;
  font-weight: 200;
  font-size: 20px;
  line-height: 30px;
}

.rUSure {
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  color: #1D1E2599;
  margin-top: 40px;
}


.confirmButtons {
  display: flex;
}

.confirmButtonYes {
  background-color: #F15F50;
  color: #FFFF;
  border: none;
  border-radius: 12px;
  width: 200px;
  height: 56px;
  padding: 18px 22px;
  justify-content: space-between;
  margin-right: 50px;

}

.confirmButtonNo:disabled {
  background-color: gray;
}

.confirmButtonNo {
  background-color: #FFFF;
  border: 1px solid #1D1E2533;
  border-radius: 12px;
  width: 200px;
  height: 56px;
  margin-right: 24px;

}

.thanksPopUp {
  padding: 50px;
  align-items: center;
  text-align: center;
}

.qr-consume-success-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 60px;
  margin-top: 30px;
}

.thanksPopUp h1 {
  font-weight: 100;
  font-size: 40px;
  line-height: 50px;
  text-align: center;
}

.closeButton button {
  background-color: #FFFF;
  border: 1px solid #1D1E251A;
  padding: 18px 22px;
  width: 130px;
  height: 56px;
  border-radius: 12px;
  justify-content: space-between;
  font-weight: 600;
  font-size: 16px;
}

.closeButton {
  display: flex;
  justify-content: end;
}


.qrSuccess {
  color: #1D1E25;
  font-weight: 400;

}

.subtitle {
  font-weight: 400;
  font-size: 14px;
  color: #1D1E2599;
  line-height: 17px;
}

.restaurant-left-image {
  width: 100%;
}

.restaurant-container {
  height: calc(100vh - 280px);
  padding: 32px;
}

.contentPart {
  max-height: 660px;
}

.create-notification {
  margin-right: 30px;
  margin-top: 15px;
  width: 150px;
  height: 55px;
  background-color: #F15F50;
  border-radius: 15px;
  border: none;
  color: white;
}

.notification-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.css-md26zr-MuiInputBase-root-MuiOutlinedInput-root {
  border-radius: 8px !important;
  padding: 30px;
}

.notification-title h1 {
  text-align: left;
  font-weight: 100;
  margin-top: 20px;

}

.no-notification {
  display: block;
  text-align: center;
  margin-top: 10%;
}

.new-notification {
  border: 1px solid #1D1E2533;
  background-color: transparent;
  margin-right: 30px;
  margin-top: 15px;
  width: 150px;
  height: 55px;
  border-radius: 15px;
  line-height: 24px;
  font-size: 18px;
  font-weight: 300;

}

.no-notification h4 {
  color: #F15F50;
  font-weight: 400;
  font-size: 24px;
  line-height: 34px;
}

.create-notification-button {
  width: 200px;
  height: 45px;
  border-radius: 10px !important;
  background-color: #F15F50 !important;
  text-transform: none !important;
  font-size: 17px !important;

}

.css-1t1j96h-MuiPaper-root-MuiDialog-paper {
  display: flex;
  text-align: left;
  justify-content: center;
  font-family: 'Sora', sans-serif !important;
  width: 550px !important;
  border-radius: 20px !important;
  padding: 15px;

}

.css-1t1j96h-MuiPaper-root-MuiDialog-paper .dialogTitle {
  font-size: 25px;
  font-weight: 200;
}

.css-1t1j96h-MuiPaper-root-MuiDialog-paper label {
  font-weight: 200;
}

.css-1t1j96h-MuiPaper-root-MuiDialog-paper Button {
  border: 1px solid black;
  border-radius: 15px;
  width: 90px !important;
  height: 30px;
  color: black;
}

.bottomLinks button {
  background-color: #F1F5F7 !important;
  border: none !important;
  text-decoration: underline;

}

.content-admin {
  max-height: calc(100vh - 300px) !important;
  height: calc(100vh - 200px) !important;
  overflow: scroll;

  padding: 15px;
}

.MuiTextField-root .Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #F15F50 !important;
}

.MuiTextField-root .MuiFormLabel-root {
  color: #1d1e259b !important;
}

.MuiTextField-root .Mui-focused .MuiFormLabel-root {
  color: #1d1e259b !important;
}

.notifications {
  list-style: none;
  list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  text-align: left;

}

.notifications-title {
  font-weight: 200;
  font-size: 18px;
  margin-bottom: 0px;
  cursor: pointer !important;
}

.notifications-creation-date {
  font-weight: 100;
  font-size: 14px;
}

.documents {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.documents-buttons {
  margin-right: 10%;

}

.documents-buttons button {
  background-color: white;
  border: none;
  width: 85px;
  border-radius: 8px;
  font-size: 14px;
}

.company-update-buttons {
  display: flex;
  justify-content: center;
  margin-bottom: 45px;
}

.preview {
  border: 1px solid #1D1E251A;
  background-color: transparent;
  width: 150px;
  height: 50px;
  border-radius: 15px;
  margin-right: 30px;
  margin-top: 32px;
}

.save-changes {
  border: none;
  border-radius: 15px;
  background-color: #F15F50;
  width: 245px;
  color: #FFFF;
  padding-top: 18px;
  padding-bottom: 18px;
  padding-left: 22px;
  padding-right: 22px;
}

.save-changes:hover {
  background-color: #f16050cd;
  border: 1px solid #1D1E2533;

}

.restoran-update-bottom-buttons-container {
  display: flex;
  justify-content: flex-start;
  margin-top: 30px;
}

.preview-button {
  background-color: transparent;
  border: 1px solid #1D1E2533;
  padding-top: 18px;
  padding-bottom: 18px;
  padding-left: 22px;
  padding-right: 22px;
  border-radius: 15px;
  width: 156px;
  margin-right: 16px;
  color: #1D1E25;
  font-weight: 600;
}

.preview-button:hover {
  background-color: #f160509b;
  border: 1px solid #1D1E2533;

}

.preview-close-container {
  display: flex;
  justify-content: flex-end !important;
}

.preview-container {
  display: flex;
  align-items: center;
}

.flash-offer-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flash-offer-title button {
  margin-top: 15px;
  width: 135px;
  font-size: 12px;
}

.flash-offer-content-area {
  margin-left: 5px !important;
  width: 95%;
  height: 40%;
  border: 1px solid #F15F50;
  border-radius: 13px;

}

.flash-offer-content-title {
  font-size: 18px;
  margin-top: 15px;
  line-height: 34px;

}

.flash-offer-content-paragraph {
  font-size: 14px;
  font-weight: 200;
  line-height: 25px;
}

.flash-offer-button {
  background-color: #F15F50;
  border: none;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 15px;
}

.flash-offer-form-paragraph {
  font-size: 16px;
  font-weight: 200;
  color: #1D1E25;
}

.flash-offer-select-button-container {
  padding: 15px;
  background-color: #F1F5F7;
  width: 95%;
  height: 60px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.flash-offer-select-button {
  border: none;
  background-color: transparent;
  padding: 12px;
  font-size: 12px;
  border-radius: 10px;
  color: #1D1E2599;

}

.flash-offer-select-button.selected {
  background-color: #FFFF;
}

.flash-offer-button:disabled {
  background-color: #1D1E2533;
}

.flash-offer-offer-1-paragraph {
  margin-top: 10px;
  color: #C8811A;
  font-size: 12px;
}

.offer-1-title-input {
  width: 95%;
  border: 1px solid #1D1E2566;
  border-radius: 8px;
  height: 40px;
  color: #1D1E25;
  padding-left: 15px;
}

.offer-1-title-input:focus {
  outline: none;
  border: 1px solid #F15F50;
}


.offer-1-content-input {
  margin-top: 15px;
  width: 95%;
  border: 1px solid #1D1E2566;
  border-radius: 8px;
  height: 120px;
  color: #1D1E25;
  padding-left: 15px;
}

.offer-1-content-input:focus {
  outline: none !important;
  border: 1px solid #F15F50;
}

.upload-image-flash-offer {
  width: 95%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 25px;
  background-color: #FFFF;
  border: 2px dashed #1D1E2533;
  border-radius: 15px;
  margin-top: 15px;
  margin-bottom: 30px;
  font-size: 14px;
  color: #1D1E25;
  font-weight: 200;
}

.flash-offer-content-container {
  padding: 20px;
  height: calc(100vh - 280px);
}

.flash-offer-upload-image-icon {
  padding: 20px;
  background-color: #87CCA1;
  z-index: -1;
  border-radius: 35px;
  margin-right: 15px;
}

.delete-flash-offer-img {
  background-color: transparent;
  border: none;
  text-decoration: underline;
  color: #F15F50;
}

.contract-flash-offer {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 24px;
  background: linear-gradient(white, white) padding-box,
    linear-gradient(90deg, #F15F50 0%, #F9B061 100%) border-box;
}


.contract-flash-offer a {
  color: #F15F50 !important;
  text-decoration: none;
}

.offer-2-buttons-container p {
  font-weight: 400;

}

.offer-2-buttons-container {
  padding: 10px;
  border: 1px solid #1D1E2533;
  border-radius: 10px;
  margin-top: 25px;
  margin-bottom: 15px;
  width: 95%;
}

.offer-3-buttons-container p {
  font-weight: 400;
  margin-top: 25px;
}

.offer-3-select-time-container {
  display: flex;
  width: 95%;
  margin-bottom: 24px;
}

.offer-3-select-time-container select {
  color: #1D1E2566;
  border: 1px solid #1D1E2533;
  padding: 15px;
  border-radius: 10px;

}

.offer-3-select-time-container select:focus {
  box-shadow: none;
  border: 2px solid #F9B061;
  outline: none;

}

.flash-offer-offer-2-buttons {
  width: 100px;
  margin: 5px;
  padding: 10px 20px;
  background-color: transparent;
  color: #1D1E2533;
  border: 2px dashed #1D1E2533;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 700;
  font-size: 20px;
  transition: 'width 0.3s ease, background 0.7s ease';
}

.flash-offer-offer-2-buttons.active {
  background: linear-gradient(90deg, #F15F50 0%, #F9B061 100%);
  border: 2px dashed #1D1E25;
  color: #FFFF;
  width: 120px;
}

.active-flash-deal-container {
  width: 95%;
  height: 250px;
  margin-top: 20px;
}

.active-flash-deal-container h6 {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;


}

.active-flash-deal-info {
  background-color: #87CCA11A;
  border: 1px solid #1D1E2599;
  border-radius: 15px;
  padding: 20px;
  height: 400px;
}

.active-flash-deal-info label {
  color: #1D1E2599;
  font-size: 13px;
  margin-right: 40px;
}

.active-flash-deal-info h5 {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
}

.active-flash-deal-info-details {
  display: flex;
  width: 100%;
}

.active-flash-deal-info-details p {
  margin-right: 20px;
}

.active-flash-deal-info-details a {
  color: #F15F50 !important;
  text-decoration: underline !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 26px;
}

.agreement {
  padding: 135px;
  border-radius: 8px;
  background-color: #1D1E25;
}

.agreement-text-div {
  background-color: white;
  padding: 16px;
  border: 1px solid #1D1E251A;
  border-radius: 8px;
  margin-top: 16px;
}

.agreement-text {
  color: #1D1E2599;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
}

.stop-session-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flash-detail-popup {
  background-color: transparent;
  border: none;
  text-decoration: underline;
  color: #F15F50;
}

.flash-deal-type-title {
  background: linear-gradient(90deg, #F15F50 0%, #F9B061 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
}

.navbar-toggle {
  display: none;
  flex-direction: column;
  cursor: pointer;
}

.bar {
  height: 2px;
  background-color: #333;
  margin: 2px 0;
  transition: 0.4s;
}

.navbar-links {
  display: flex;
  justify-content: space-between;
}

.qrButtonMobile {
  display: none;
}
#qr-consume-button:disabled{
  background-color: #1D1E2533;
  color: #1D1E2566;
  margin-top: 24px;
 }
 #qr-consume-button{
  margin-top: 24px;
  width: 100% !important;
  background-color: #F15F50;
  color: white;
  font-size: 16px;
  font-weight: 600;

 }
@media (max-width: 768px) {
  .upper-div{
    background-position-x: -115px !important;
  }
  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link{
    width: 115px !important;
  }
  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    border-radius: 8px;
    width: 131px !important;
    height: 60px !important;
    padding: 5px 32px;
  }
  .companyTitle h2{
    font-size: 24px;
    line-height: unset;
  }
  .titleOnline h2{
    font-size: 24px !important;
  }
  .companyTitle{
    padding: 10px;
    margin-left: 0px;
    margin-right: 0px;
  }
  .qrButton{
    display: none;
  }
  .middleDiv{
    display: none !important;
  }
  .qrButtonMobile{
    display: flex;
    background-color: #F15F50;
    margin-top: 35px;
    margin-right: 8px !important;
  }
  .navbar-toggle {
    width: 64px;
    display: flex;
    background-color: white;
    padding: 16px 22px;
    border-radius: 8px;
    height: 52px;
  }

  .navbar-links {
    display: none;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.9); 
    z-index: 1000;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }
  .navbar-right{
    display: none;
  }
  .logout-button-mobile{
    display: block;
  }
  .navbar-links.active {
    display: flex;
    opacity: 1;
    /* background-color: #F15F50; */
    margin-left: 0px;
  }
  .navbar-links-container{
    padding: 15px;
    background-color: red;
  }
  .navbar-links li {  
    list-style: none;
    margin: 20px 0;
  }

  .navbar-links li button {
    font-size: 24px;
    color: white;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: color 0.3s;
  }

  .navbar-links li button:hover {
    color: #F15F50;
  }

  .timerMobileButton{
    width: 170px !important;
  }
  #companyBecomeOnlineButton button{
    width: 100% !important;
  }
  .timeButtonsForExtendSession{
    height: 200px !important;
  }
  .stop-button{
    width:80px;
    font-size: 13px;
    padding: 0px;
  }
  .stop-button .icon {
    display: none;
  }
  .company-select-buttons{
    overflow: auto;
  }
  .company-select-buttons button{
    font-size: 16px !important;
    padding: 0px 32px !important;
    line-height: 20px  !important;
  }
  .offer-3-select-time-container{
    display: block;
  }
  .restaurant-opening{
    width: 100% !important;
  }
  .restaurant-closing{
    width: 105% !important;
  }

  .comingSoon{
    margin-bottom: 50px;
    margin-top: 50px;
  }
  .confirmButtonNo{
    padding: unset;
  }
  .preview-title{
    font-size: 17px !important;
    line-height: 25px !important;
    margin-left: 20px !important;
  }
  .preview-content{
    width: 60% !important;
    min-height: 60% !important;
    max-height: 95% !important;
    height: 100% !important;
  }
  .preview-content h3 {
    font-size: 12px !important;
  }
  .phone-banner{
    width:unset !important;
    min-width: 60% !important;
    border-top-left-radius: 25px !important;
    border-top-right-radius: 25px !important;
  }
  .phone-logo{
    width: 50px !important;
    height: 50px !important;
    top: 40% !important;
    left: 25% !important;
  }
  .phone-container{
    padding-top: 100% !important;
  }
  
  .agreement{
    padding: 16px !important;
  }
  .timeButtons{
    padding: 8px;
  }
  #timeButtons button{
    width: 70px !important;
    height: 55px;
    margin-bottom: 8px;
  }
  #timeButtons .show-more-button{
    width: 200px !important;
  }
  .modal-content button {
    width: 70px !important;
  }
 .liveRightNov h2{
  font-weight: 600 !important;
  padding-left: 0px !important;
 }
 .liveRightNov h6 {
  font-weight: 400 !important;
  color: #1D1E25 !important;
 }
 .liveRightNov{
  margin-left: 0px !important;
  display: block !important;

 }
 .confirmButtons{
  display: block !important;
 }
 #confirmButtonNo{
  width: 100% !important ;
  margin-bottom: 16px !important;
  margin-right: 0px !important;

 }
 #confirmButtonYes{
  width: 100% !important;
  margin-bottom: 16px !important;
  margin-right: 0px !important;
 }
 #companyBecomeOnlineButton button{
  width: 95% !important;
  height: 56px !important;
  background-color: #F15F50;
  border: none;
  color: #FFFF;
 }
 #qr-consume-button:disabled{
  background-color: #1D1E2533;
  color: #1D1E2566;
 }
 #qr-consume-button{
  width: 100% !important;
  background-color: #F15F50;
  color: white;
  font-size: 16px;
  font-weight: 600;

 }
 .restoran-update-bottom-buttons-container{
  display: block;
  margin-bottom: 24px;
 }
 .preview-button{
  margin-bottom: 16px;
 }
 #success-popup-close-button{
  width: 100% !important;
 }
 .left-content::after{
  display: none;
 }
 .companyBecomeOnlineButton button{
  width: 100%;
 }
 .preview-title{
  display: none;
 }
 .qr-consume-container{
  padding: 16px !important;
 }
 .companyInfoFormContainer{
  margin-left: -26px !important;
 }
 .restoran-update-bottom-buttons-container{
  margin-top: 0px !important;
 }
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7); 
  z-index: 10;
}

.disabled .upperContent-p, .disabled hr , .disabled .saleButtons, .disabled .contract, .disabled .companyBecomeOnlineButton{
  pointer-events: none;
  opacity: 0.2;
}

.modal-content {
  position: relative;
  z-index: 20;
}

.active-buttons {
  position: relative;
  z-index: 20; 
  pointer-events: auto; 
}

@media screen and (max-width: 1050px) {

  .navbar-links li button {
    font-size: 20px;
  }

  .overlay-div {
    height: calc(100vh - 282px);

  }
}

@media screen and (max-width: 835px) {
  .overlay-div {
    margin-top: 13% !important;
    height: calc(100vh - 250px);
  }
  .navbar-links li {
    margin-right: 10px;
  }
  .navbar{
    align-items: baseline;
  }
}

@media screen and (max-width: 920px) {

  .navbar-links {
    font-size: 15px;
    margin-left: -15px;
  }
}

@media screen and (max-width: 832px) {
  .navbar-logo {
    margin-left: 0;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/styles/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;AAErB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,kEAAkE;EAClE,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;;;AAIA;EACE,aAAa;AACf;;;AAGA;EACE,yBAAyB;EACzB,yDAAiD;EACjD,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;;AAEf;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,UAAU;;EAEZ;;AAEF;;AAEA;EACE;;IAEE,UAAU;;EAEZ;;AAEF;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;;;;EAIlB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,2BAA2B;EAC3B;uBACqB;AACvB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;;AAEtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;;AAGA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAAsB;EAAtB,sBAAsB;EACtB,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,qCAAqC;EACrC,4DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;;;AAGb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;;;AAG/B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;;AAGA;;;GAGG;;AAEH;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;;AAErB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;;AAEpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;;AAEpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;;AAGA;EACE,cAAc;EACd,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;AAElB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;EAC/B,0BAA0B;;AAE5B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,0CAA0C;EAC1C,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;;AAEf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,0BAA0B;;AAE5B;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,gBAAgB;;EAEhB,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,yDAAwD;EACxD,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;;AAEnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;;AAE7B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;;AAE7B;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,mBAAmB;;AAErB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;;AAElB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;;AAGA;EACE,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb;+DAC6D;AAC/D;;;AAGA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;;AAEf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,4DAA4D;EAC5D,0BAA0B;EAC1B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;;AAGnB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,4DAA4D;EAC5D,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;CACjB;CACA;EACC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;;CAEjB;AACD;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,UAAU;IACV,+BAA+B;IAC/B,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,4BAA4B;EAC9B;EACA;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;EAC1C;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;CACD;EACC,2BAA2B;EAC3B,4BAA4B;CAC7B;CACA;EACC,2BAA2B;EAC3B,yBAAyB;CAC1B;CACA;EACC,2BAA2B;EAC3B,yBAAyB;;CAE1B;CACA;EACC,yBAAyB;CAC1B;CACA;EACC,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;;CAE7B;CACA;EACC,sBAAsB;EACtB,8BAA8B;EAC9B,4BAA4B;CAC7B;CACA;EACC,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,YAAY;CACb;CACA;EACC,2BAA2B;EAC3B,gBAAgB;CACjB;CACA;EACC,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;;CAEjB;CACA;EACC,cAAc;EACd,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,sBAAsB;CACvB;CACA;EACC,aAAa;CACd;CACA;EACC,WAAW;CACZ;CACA;EACC,aAAa;CACd;CACA;EACC,wBAAwB;CACzB;CACA;EACC,6BAA6B;CAC9B;CACA;EACC,0BAA0B;CAC3B;AACD;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;;EAE7B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;;EAEE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;AAEF","sourcesContent":["html {\n  background-color: #F1F5F7;\n}\n\n* {\n  font-family: 'Sora', sans-serif;\n  scroll-behavior: smooth;\n}\n\n.container-fluid {\n  max-height: 100vh;\n  overflow-y: auto;\n}\n\n.horizontal-container {\n  display: grid;\n  height: 100vh;\n}\n\n.horizontal-div {\n  height: 380px;\n  flex: 1;\n  background-color: #F1F5F7;\n}\n\n.navbar {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 10px 20px;\n  background-color: transparent;\n  color: #fff;\n}\n\n.navbar-right {\n  list-style: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n}\n\n.navbar-right li {\n  margin-right: 5px;\n}\n\n.logout-button-mobile{\n  display: none;\n}\n\n.companyButton {\n  display: flex;\n  margin-bottom: 30px;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  height: 40px;\n  background-color: #50536789;\n  border: none;\n  border-radius: 5px;\n  padding: 10px;\n  color: #F15F50;\n}\n\n.navbar-logo {\n  margin-left: 100px;\n  margin-top: 30px;\n  display: flex;\n  padding: 20px;\n  justify-content: center;\n  align-items: center;\n  width: 100px;\n  height: 100px;\n  border-radius: 75px;\n  background-color: #FFFF;\n}\n\n.navbar-logo img {\n  width: 85px;\n  height: 65px;\n}\n\n.navbar-links {\n  font-weight: 100;\n  font-size: 20px;\n  cursor: pointer;\n  list-style: none;\n  display: flex;\n}\n\n.navbar-links li {\n  margin-right: 20px;\n}\n\n.navbar-links li button {\n  background-color: transparent;\n  border: none;\n  font-weight: 100;\n  color: #fff;\n  cursor: pointer;\n  line-height: 34px;\n  font-size: 24px;\n  transition: color 0.3s, font-weight 0.3s;\n}\n\n.navbar-links li button.active {\n  background-image: linear-gradient(90deg, #F15F50 0%, #F9B061 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  font-weight: 700;\n}\n\n\n\n.navbar-links li button:focus {\n  outline: none;\n}\n\n\n.upper-div {\n  background-color: #1D1E25;\n  background-image: url('../images/Pattern\\ 2.png');\n  background-repeat: no-repeat;\n  background-position-x: -10px;\n  background-position-y: -60px;\n  background-size: 454px;\n  display: flex;\n\n}\n\n\n.left-content {\n  position: relative;\n}\n\n.left-content::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 57%;\n  width: 1px;\n  height: 130px;\n  background-color: #c7c8c9;\n}\n\n@media screen and (min-width: 1501px) {\n  .left-content::after {\n\n    right: 60%;\n\n  }\n\n}\n\n@media screen and (max-width: 1500px) {\n  .left-content::after {\n\n    right: 55%;\n\n  }\n\n}\n\n.second-div {\n  background-color: #F1F5F7;\n  width: 100%;\n}\n\n.overlay-div {\n  border-radius: 25px;\n  position: absolute;\n\n\n\n  z-index: 10;\n  background-color: #ffff;\n  border-radius: 5px;\n  top: 240px;\n  left: 90px;\n  width: calc(100% - 180px);\n  height: calc(100vh - 280px);\n  /* overflow-y: hidden;\n  overflow-x: hidden; */\n}\n\n\n.companyTitle {\n  width: 100%;\n  color: #FFFF;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  padding: 15px;\n  margin-left: 55px;\n  margin-right: 55px;\n  margin-bottom: 120px;\n\n}\n\n.companyTitle h2 {\n  font-weight: 100;\n  font-size: 36px;\n  line-height: 46px;\n}\n\n@media (max-width: 768px) {\n  .horizontal-container {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n.backgroundDiv {\n  height: calc(100vh - 280px);\n  padding: 0px;\n}\n\n.backgroundDiv img {\n  height: 100%;\n  width: 100%;\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 12px;\n}\n\n.contentDiv p {\n  font-size: 16px;\n  width: 90%;\n  overflow: auto;\n}\n\n.contentDiv {\n  height: calc(100vh - 280px);\n  padding: 16px;\n  margin-left: 32px;\n}\n\n.row>* {\n  padding: 0px;\n}\n\n.titleOnline h2 {\n  font-weight: 100 !important;\n  margin-top: 20px;\n  font-size: 36px;\n}\n\n.upperContent {\n  max-width: fit-content;\n  max-height: 100%;\n}\n\n\n.upperContent-p {\n  font-weight: 200;\n  font-size: 20px !important;\n  width: 100% !important;\n  padding: 0px !important;\n}\n\n.upperContent button {\n  border-radius: 12px;\n  background-color: #fff;\n  padding: 16px 32px;\n  border: 2px dashed #87CCA1;\n  font-weight: 600;\n  font-size: 25px;\n  margin-bottom: 25px;\n}\n\n.timeButtons{\n  width: 95%;\n  padding: 32px;\n  border: 1px solid #1D1E2533;\n  border-radius: 8px;\n  margin-bottom: 40px;\n  background-color: #F1F5F7;\n}\n.timeButtons button {\n  border: 2px dashed #1D1E251A;\n  color: #1D1E25CC;\n  width: 120px;\n  height: 60px;\n  padding: 10px;\n  font-size: 20px;\n  background-color: #FFFF;\n  border-radius: 8px;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  font-weight: 700;\n}\n\n.timeButtonsForExtendSession {\n  background-color: #F9FBFC !important;\n  padding: 30px;\n  border: 1px solid #1D1E2533;\n  border-radius: 8px;\n  height: 300px !important;\n  width: 95%;\n  margin-bottom: 40px;\n}\n\n.timeButtonsForExtendSession button {\n  width: 120px !important;\n  height: 60px !important;\n  border: 2px dashed #1D1E2533;\n  margin-right: 8px;\n  color: #1D1E2533;\n  padding: 0px !important;\n}\n\n\n.saleButtons button {\n  border: 2px dashed #1D1E2533;\n  margin-right: 8px;\n  color: #1D1E2533;\n}\n\n\n.selected-button {\n  border: 2px dashed #1D1E25 !important;\n  background: linear-gradient(90deg, #F15F50 0%, #F9B061 100%);\n  color: #fff !important;\n}\n\n.contract {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px;\n  border: 1px solid #1D1E2533;\n  border-radius: 8px;\n  margin-bottom: 24px;\n  width: 100%;\n\n\n}\n\n.contract p {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  margin-bottom: 0px !important;\n\n\n}\n\n.contract a {\n  color: #F15F50 !important;\n}\n\n\n.companyBecomeOnlineButton button {\n  background-color: #F15F50;\n  border: none;\n  padding: 18px 22px;\n  width: 312px;\n  height: 56px;\n  border-radius: 12px;\n  justify-content: space-between;\n  color: #fff;\n  font-weight: 600;\n  font-size: 16px;\n}\n.companyBecomeOnlineButton button:disabled{\n  background-color: #1D1E2533;\n  color: #1D1E2566;\n}\n\n.liveRightNov {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.stop-session-button {\n  border: 1px solid #1D1E2533;\n  background-color: #FFFF;\n  justify-content: space-between;\n  padding: 18px 22px;\n  width: 142px;\n  height: 56px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n}\n\n.liveRightNowUpperParagraph {\n  font-weight: 400 !important;\n  font-size: 24px;\n  line-height: 34px;\n}\n\n.timerButton {\n  border: 2px dashed #1D1E25 !important;\n}\n\n.timerButtonExtendSession {\n  border: none !important;\n  text-align: left;\n  font-weight: 600;\n  font-size: 30px !important;\n  padding: 0px !important;\n}\n\n.timePickerButtons {\n  width: 50px !important;\n  height: 50px;\n}\n\n.ReactModal__Content {\n  inset: 100% !important;\n}\n\n.custom-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.popup-content {\n  width: 100%;\n  max-width: 800px;\n  height: 750px;\n  background: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  position: relative;\n  z-index: 1001;\n  padding: 20px;\n  border-radius: 8px;\n}\n\n\n/* .stop-session-pop-up{\n  width: 50%;\n  inset:0px !important;\n} */\n\n.companyInfoFormContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n}\n\n.companyInfoForm {\n  width: 90%;\n  margin-left: 32px;\n}\n\n.stopSession {\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n}\n\n.stopSession button {\n  background-color: #FFFF;\n  border: 1px solid #1D1E251A;\n  padding: 18px 22px;\n  width: 130px;\n  height: 56px;\n  border-radius: 12px;\n  justify-content: space-between;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.content h5 {\n  color: #CD3636;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n  margin-top: 50px;\n}\n\n.stopSessionFirstP {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n}\n\n.stopSessionSecondP {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n}\n\n.qrCount {\n  color: #CD3636;\n  font-weight: 200;\n  font-size: 20px;\n  line-height: 30px;\n}\n\n.rUSure {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 17px;\n  color: #1D1E2599;\n  margin-top: 40px;\n}\n\n\n.confirmButtons {\n  display: flex;\n}\n\n.confirmButtonYes {\n  background-color: #F15F50;\n  color: #FFFF;\n  border: none;\n  border-radius: 12px;\n  width: 200px;\n  height: 56px;\n  padding: 18px 22px;\n  justify-content: space-between;\n  margin-right: 50px;\n\n}\n\n.confirmButtonNo:disabled {\n  background-color: gray;\n}\n\n.confirmButtonNo {\n  background-color: #FFFF;\n  border: 1px solid #1D1E2533;\n  border-radius: 12px;\n  width: 200px;\n  height: 56px;\n  margin-right: 24px;\n\n}\n\n.thanksPopUp {\n  padding: 50px;\n  align-items: center;\n  text-align: center;\n}\n\n.qr-consume-success-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 60px;\n  margin-top: 30px;\n}\n\n.thanksPopUp h1 {\n  font-weight: 100;\n  font-size: 40px;\n  line-height: 50px;\n  text-align: center;\n}\n\n.closeButton button {\n  background-color: #FFFF;\n  border: 1px solid #1D1E251A;\n  padding: 18px 22px;\n  width: 130px;\n  height: 56px;\n  border-radius: 12px;\n  justify-content: space-between;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.closeButton {\n  display: flex;\n  justify-content: end;\n}\n\n\n.qrSuccess {\n  color: #1D1E25;\n  font-weight: 400;\n\n}\n\n.subtitle {\n  font-weight: 400;\n  font-size: 14px;\n  color: #1D1E2599;\n  line-height: 17px;\n}\n\n.restaurant-left-image {\n  width: 100%;\n}\n\n.restaurant-container {\n  height: calc(100vh - 280px);\n  padding: 32px;\n}\n\n.contentPart {\n  max-height: 660px;\n}\n\n.create-notification {\n  margin-right: 30px;\n  margin-top: 15px;\n  width: 150px;\n  height: 55px;\n  background-color: #F15F50;\n  border-radius: 15px;\n  border: none;\n  color: white;\n}\n\n.notification-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.css-md26zr-MuiInputBase-root-MuiOutlinedInput-root {\n  border-radius: 8px !important;\n  padding: 30px;\n}\n\n.notification-title h1 {\n  text-align: left;\n  font-weight: 100;\n  margin-top: 20px;\n\n}\n\n.no-notification {\n  display: block;\n  text-align: center;\n  margin-top: 10%;\n}\n\n.new-notification {\n  border: 1px solid #1D1E2533;\n  background-color: transparent;\n  margin-right: 30px;\n  margin-top: 15px;\n  width: 150px;\n  height: 55px;\n  border-radius: 15px;\n  line-height: 24px;\n  font-size: 18px;\n  font-weight: 300;\n\n}\n\n.no-notification h4 {\n  color: #F15F50;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n}\n\n.create-notification-button {\n  width: 200px;\n  height: 45px;\n  border-radius: 10px !important;\n  background-color: #F15F50 !important;\n  text-transform: none !important;\n  font-size: 17px !important;\n\n}\n\n.css-1t1j96h-MuiPaper-root-MuiDialog-paper {\n  display: flex;\n  text-align: left;\n  justify-content: center;\n  font-family: 'Sora', sans-serif !important;\n  width: 550px !important;\n  border-radius: 20px !important;\n  padding: 15px;\n\n}\n\n.css-1t1j96h-MuiPaper-root-MuiDialog-paper .dialogTitle {\n  font-size: 25px;\n  font-weight: 200;\n}\n\n.css-1t1j96h-MuiPaper-root-MuiDialog-paper label {\n  font-weight: 200;\n}\n\n.css-1t1j96h-MuiPaper-root-MuiDialog-paper Button {\n  border: 1px solid black;\n  border-radius: 15px;\n  width: 90px !important;\n  height: 30px;\n  color: black;\n}\n\n.bottomLinks button {\n  background-color: #F1F5F7 !important;\n  border: none !important;\n  text-decoration: underline;\n\n}\n\n.content-admin {\n  max-height: calc(100vh - 300px) !important;\n  height: calc(100vh - 200px) !important;\n  overflow: scroll;\n\n  padding: 15px;\n}\n\n.MuiTextField-root .Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #F15F50 !important;\n}\n\n.MuiTextField-root .MuiFormLabel-root {\n  color: #1d1e259b !important;\n}\n\n.MuiTextField-root .Mui-focused .MuiFormLabel-root {\n  color: #1d1e259b !important;\n}\n\n.notifications {\n  list-style: none;\n  list-style-image: url('../images/icons/Ellipse\\ 21.png');\n  text-align: left;\n\n}\n\n.notifications-title {\n  font-weight: 200;\n  font-size: 18px;\n  margin-bottom: 0px;\n  cursor: pointer !important;\n}\n\n.notifications-creation-date {\n  font-weight: 100;\n  font-size: 14px;\n}\n\n.documents {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.documents-buttons {\n  margin-right: 10%;\n\n}\n\n.documents-buttons button {\n  background-color: white;\n  border: none;\n  width: 85px;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.company-update-buttons {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 45px;\n}\n\n.preview {\n  border: 1px solid #1D1E251A;\n  background-color: transparent;\n  width: 150px;\n  height: 50px;\n  border-radius: 15px;\n  margin-right: 30px;\n  margin-top: 32px;\n}\n\n.save-changes {\n  border: none;\n  border-radius: 15px;\n  background-color: #F15F50;\n  width: 245px;\n  color: #FFFF;\n  padding-top: 18px;\n  padding-bottom: 18px;\n  padding-left: 22px;\n  padding-right: 22px;\n}\n\n.save-changes:hover {\n  background-color: #f16050cd;\n  border: 1px solid #1D1E2533;\n\n}\n\n.restoran-update-bottom-buttons-container {\n  display: flex;\n  justify-content: flex-start;\n  margin-top: 30px;\n}\n\n.preview-button {\n  background-color: transparent;\n  border: 1px solid #1D1E2533;\n  padding-top: 18px;\n  padding-bottom: 18px;\n  padding-left: 22px;\n  padding-right: 22px;\n  border-radius: 15px;\n  width: 156px;\n  margin-right: 16px;\n  color: #1D1E25;\n  font-weight: 600;\n}\n\n.preview-button:hover {\n  background-color: #f160509b;\n  border: 1px solid #1D1E2533;\n\n}\n\n.preview-close-container {\n  display: flex;\n  justify-content: flex-end !important;\n}\n\n.preview-container {\n  display: flex;\n  align-items: center;\n}\n\n.flash-offer-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.flash-offer-title button {\n  margin-top: 15px;\n  width: 135px;\n  font-size: 12px;\n}\n\n.flash-offer-content-area {\n  margin-left: 5px !important;\n  width: 95%;\n  height: 40%;\n  border: 1px solid #F15F50;\n  border-radius: 13px;\n\n}\n\n.flash-offer-content-title {\n  font-size: 18px;\n  margin-top: 15px;\n  line-height: 34px;\n\n}\n\n.flash-offer-content-paragraph {\n  font-size: 14px;\n  font-weight: 200;\n  line-height: 25px;\n}\n\n.flash-offer-button {\n  background-color: #F15F50;\n  border: none;\n  padding: 10px;\n  border-radius: 10px;\n  margin-bottom: 15px;\n}\n\n.flash-offer-form-paragraph {\n  font-size: 16px;\n  font-weight: 200;\n  color: #1D1E25;\n}\n\n.flash-offer-select-button-container {\n  padding: 15px;\n  background-color: #F1F5F7;\n  width: 95%;\n  height: 60px;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.flash-offer-select-button {\n  border: none;\n  background-color: transparent;\n  padding: 12px;\n  font-size: 12px;\n  border-radius: 10px;\n  color: #1D1E2599;\n\n}\n\n.flash-offer-select-button.selected {\n  background-color: #FFFF;\n}\n\n.flash-offer-button:disabled {\n  background-color: #1D1E2533;\n}\n\n.flash-offer-offer-1-paragraph {\n  margin-top: 10px;\n  color: #C8811A;\n  font-size: 12px;\n}\n\n.offer-1-title-input {\n  width: 95%;\n  border: 1px solid #1D1E2566;\n  border-radius: 8px;\n  height: 40px;\n  color: #1D1E25;\n  padding-left: 15px;\n}\n\n.offer-1-title-input:focus {\n  outline: none;\n  border: 1px solid #F15F50;\n}\n\n\n.offer-1-content-input {\n  margin-top: 15px;\n  width: 95%;\n  border: 1px solid #1D1E2566;\n  border-radius: 8px;\n  height: 120px;\n  color: #1D1E25;\n  padding-left: 15px;\n}\n\n.offer-1-content-input:focus {\n  outline: none !important;\n  border: 1px solid #F15F50;\n}\n\n.upload-image-flash-offer {\n  width: 95%;\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  padding: 25px;\n  background-color: #FFFF;\n  border: 2px dashed #1D1E2533;\n  border-radius: 15px;\n  margin-top: 15px;\n  margin-bottom: 30px;\n  font-size: 14px;\n  color: #1D1E25;\n  font-weight: 200;\n}\n\n.flash-offer-content-container {\n  padding: 20px;\n  height: calc(100vh - 280px);\n}\n\n.flash-offer-upload-image-icon {\n  padding: 20px;\n  background-color: #87CCA1;\n  z-index: -1;\n  border-radius: 35px;\n  margin-right: 15px;\n}\n\n.delete-flash-offer-img {\n  background-color: transparent;\n  border: none;\n  text-decoration: underline;\n  color: #F15F50;\n}\n\n.contract-flash-offer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  padding: 24px;\n  background: linear-gradient(white, white) padding-box,\n    linear-gradient(90deg, #F15F50 0%, #F9B061 100%) border-box;\n}\n\n\n.contract-flash-offer a {\n  color: #F15F50 !important;\n  text-decoration: none;\n}\n\n.offer-2-buttons-container p {\n  font-weight: 400;\n\n}\n\n.offer-2-buttons-container {\n  padding: 10px;\n  border: 1px solid #1D1E2533;\n  border-radius: 10px;\n  margin-top: 25px;\n  margin-bottom: 15px;\n  width: 95%;\n}\n\n.offer-3-buttons-container p {\n  font-weight: 400;\n  margin-top: 25px;\n}\n\n.offer-3-select-time-container {\n  display: flex;\n  width: 95%;\n  margin-bottom: 24px;\n}\n\n.offer-3-select-time-container select {\n  color: #1D1E2566;\n  border: 1px solid #1D1E2533;\n  padding: 15px;\n  border-radius: 10px;\n\n}\n\n.offer-3-select-time-container select:focus {\n  -webkit-box-shadow: #e9a46b !important;\n  box-shadow: none;\n  border: 2px solid #F9B061;\n  outline: none;\n\n}\n\n.flash-offer-offer-2-buttons {\n  width: 100px;\n  margin: 5px;\n  padding: 10px 20px;\n  background-color: transparent;\n  color: #1D1E2533;\n  border: 2px dashed #1D1E2533;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 20px;\n  transition: 'width 0.3s ease, background 0.7s ease';\n}\n\n.flash-offer-offer-2-buttons.active {\n  background: linear-gradient(90deg, #F15F50 0%, #F9B061 100%);\n  border: 2px dashed #1D1E25;\n  color: #FFFF;\n  width: 120px;\n}\n\n.active-flash-deal-container {\n  width: 95%;\n  height: 250px;\n  margin-top: 20px;\n}\n\n.active-flash-deal-container h6 {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20px;\n\n\n}\n\n.active-flash-deal-info {\n  background-color: #87CCA11A;\n  border: 1px solid #1D1E2599;\n  border-radius: 15px;\n  padding: 20px;\n  height: 400px;\n}\n\n.active-flash-deal-info label {\n  color: #1D1E2599;\n  font-size: 13px;\n  margin-right: 40px;\n}\n\n.active-flash-deal-info h5 {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 30px;\n}\n\n.active-flash-deal-info-details {\n  display: flex;\n  width: 100%;\n}\n\n.active-flash-deal-info-details p {\n  margin-right: 20px;\n}\n\n.active-flash-deal-info-details a {\n  color: #F15F50 !important;\n  text-decoration: underline !important;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 26px;\n}\n\n.agreement {\n  padding: 135px;\n  border-radius: 8px;\n  background-color: #1D1E25;\n}\n\n.agreement-text-div {\n  background-color: white;\n  padding: 16px;\n  border: 1px solid #1D1E251A;\n  border-radius: 8px;\n  margin-top: 16px;\n}\n\n.agreement-text {\n  color: #1D1E2599;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n.stop-session-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.flash-detail-popup {\n  background-color: transparent;\n  border: none;\n  text-decoration: underline;\n  color: #F15F50;\n}\n\n.flash-deal-type-title {\n  background: linear-gradient(90deg, #F15F50 0%, #F9B061 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: 700;\n}\n\n.navbar-toggle {\n  display: none;\n  flex-direction: column;\n  cursor: pointer;\n}\n\n.bar {\n  height: 2px;\n  background-color: #333;\n  margin: 2px 0;\n  transition: 0.4s;\n}\n\n.navbar-links {\n  display: flex;\n  justify-content: space-between;\n}\n\n.qrButtonMobile {\n  display: none;\n}\n#qr-consume-button:disabled{\n  background-color: #1D1E2533;\n  color: #1D1E2566;\n  margin-top: 24px;\n }\n #qr-consume-button{\n  margin-top: 24px;\n  width: 100% !important;\n  background-color: #F15F50;\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n\n }\n@media (max-width: 768px) {\n  .upper-div{\n    background-position-x: -115px !important;\n  }\n  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link{\n    width: 115px !important;\n  }\n  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\n    border-radius: 8px;\n    width: 131px !important;\n    height: 60px !important;\n    padding: 5px 32px;\n  }\n  .companyTitle h2{\n    font-size: 24px;\n    line-height: unset;\n  }\n  .titleOnline h2{\n    font-size: 24px !important;\n  }\n  .companyTitle{\n    padding: 10px;\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n  .qrButton{\n    display: none;\n  }\n  .middleDiv{\n    display: none !important;\n  }\n  .qrButtonMobile{\n    display: flex;\n    background-color: #F15F50;\n    margin-top: 35px;\n    margin-right: 8px !important;\n  }\n  .navbar-toggle {\n    width: 64px;\n    display: flex;\n    background-color: white;\n    padding: 16px 22px;\n    border-radius: 8px;\n    height: 52px;\n  }\n\n  .navbar-links {\n    display: none;\n    flex-direction: column;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    width: 100vw;\n    background-color: rgba(0, 0, 0, 0.9); \n    z-index: 1000;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n  }\n  .navbar-right{\n    display: none;\n  }\n  .logout-button-mobile{\n    display: block;\n  }\n  .navbar-links.active {\n    display: flex;\n    opacity: 1;\n    /* background-color: #F15F50; */\n    margin-left: 0px;\n  }\n  .navbar-links-container{\n    padding: 15px;\n    background-color: red;\n  }\n  .navbar-links li {  \n    list-style: none;\n    margin: 20px 0;\n  }\n\n  .navbar-links li button {\n    font-size: 24px;\n    color: white;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    transition: color 0.3s;\n  }\n\n  .navbar-links li button:hover {\n    color: #F15F50;\n  }\n\n  .timerMobileButton{\n    width: 170px !important;\n  }\n  #companyBecomeOnlineButton button{\n    width: 100% !important;\n  }\n  .timeButtonsForExtendSession{\n    height: 200px !important;\n  }\n  .stop-button{\n    width:80px;\n    font-size: 13px;\n    padding: 0px;\n  }\n  .stop-button .icon {\n    display: none;\n  }\n  .company-select-buttons{\n    overflow: auto;\n  }\n  .company-select-buttons button{\n    font-size: 16px !important;\n    padding: 0px 32px !important;\n    line-height: 20px  !important;\n  }\n  .offer-3-select-time-container{\n    display: block;\n  }\n  .restaurant-opening{\n    width: 100% !important;\n  }\n  .restaurant-closing{\n    width: 105% !important;\n  }\n\n  .comingSoon{\n    margin-bottom: 50px;\n    margin-top: 50px;\n  }\n  .confirmButtonNo{\n    padding: unset;\n  }\n  .preview-title{\n    font-size: 17px !important;\n    line-height: 25px !important;\n    margin-left: 20px !important;\n  }\n  .preview-content{\n    width: 60% !important;\n    min-height: 60% !important;\n    max-height: 95% !important;\n    height: 100% !important;\n  }\n  .preview-content h3 {\n    font-size: 12px !important;\n  }\n  .phone-banner{\n    width:unset !important;\n    min-width: 60% !important;\n    border-top-left-radius: 25px !important;\n    border-top-right-radius: 25px !important;\n  }\n  .phone-logo{\n    width: 50px !important;\n    height: 50px !important;\n    top: 40% !important;\n    left: 25% !important;\n  }\n  .phone-container{\n    padding-top: 100% !important;\n  }\n  \n  .agreement{\n    padding: 16px !important;\n  }\n  .timeButtons{\n    padding: 8px;\n  }\n  #timeButtons button{\n    width: 70px !important;\n    height: 55px;\n    margin-bottom: 8px;\n  }\n  #timeButtons .show-more-button{\n    width: 200px !important;\n  }\n  .modal-content button {\n    width: 70px !important;\n  }\n .liveRightNov h2{\n  font-weight: 600 !important;\n  padding-left: 0px !important;\n }\n .liveRightNov h6 {\n  font-weight: 400 !important;\n  color: #1D1E25 !important;\n }\n .liveRightNov{\n  margin-left: 0px !important;\n  display: block !important;\n\n }\n .confirmButtons{\n  display: block !important;\n }\n #confirmButtonNo{\n  width: 100% !important ;\n  margin-bottom: 16px !important;\n  margin-right: 0px !important;\n\n }\n #confirmButtonYes{\n  width: 100% !important;\n  margin-bottom: 16px !important;\n  margin-right: 0px !important;\n }\n #companyBecomeOnlineButton button{\n  width: 95% !important;\n  height: 56px !important;\n  background-color: #F15F50;\n  border: none;\n  color: #FFFF;\n }\n #qr-consume-button:disabled{\n  background-color: #1D1E2533;\n  color: #1D1E2566;\n }\n #qr-consume-button{\n  width: 100% !important;\n  background-color: #F15F50;\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n\n }\n .restoran-update-bottom-buttons-container{\n  display: block;\n  margin-bottom: 24px;\n }\n .preview-button{\n  margin-bottom: 16px;\n }\n #success-popup-close-button{\n  width: 100% !important;\n }\n .left-content::after{\n  display: none;\n }\n .companyBecomeOnlineButton button{\n  width: 100%;\n }\n .preview-title{\n  display: none;\n }\n .qr-consume-container{\n  padding: 16px !important;\n }\n .companyInfoFormContainer{\n  margin-left: -26px !important;\n }\n .restoran-update-bottom-buttons-container{\n  margin-top: 0px !important;\n }\n}\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.7); \n  z-index: 10;\n}\n\n.disabled .upperContent-p, .disabled hr , .disabled .saleButtons, .disabled .contract, .disabled .companyBecomeOnlineButton{\n  pointer-events: none;\n  opacity: 0.2;\n}\n\n.modal-content {\n  position: relative;\n  z-index: 20;\n}\n\n.active-buttons {\n  position: relative;\n  z-index: 20; \n  pointer-events: auto; \n}\n\n@media screen and (max-width: 1050px) {\n\n  .navbar-links li button {\n    font-size: 20px;\n  }\n\n  .overlay-div {\n    height: calc(100vh - 282px);\n\n  }\n}\n\n@media screen and (max-width: 835px) {\n  .overlay-div {\n    margin-top: 13% !important;\n    height: calc(100vh - 250px);\n  }\n  .navbar-links li {\n    margin-right: 10px;\n  }\n  .navbar{\n    align-items: baseline;\n  }\n}\n\n@media screen and (max-width: 920px) {\n\n  .navbar-links {\n    font-size: 15px;\n    margin-left: -15px;\n  }\n}\n\n@media screen and (max-width: 832px) {\n  .navbar-logo {\n    margin-left: 0;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
